import type { Map as MapboxMap } from 'mapbox-gl';
import { FOG_DEFAULT, FOG_STORM } from '../core/constants';

export class WeatherSystem {
  private map: MapboxMap;
  private startRainFn: (() => void) | null = null;
  private stopRainFn: (() => void) | null = null;
  private setStormCloudsFn: ((storm: boolean) => void) | null = null;

  constructor(map: MapboxMap, rainControls: { start: () => void; stop: () => void; setStormClouds?: (storm: boolean) => void }) {
    this.map = map;
    this.startRainFn = rainControls.start;
    this.stopRainFn = rainControls.stop;
    this.setStormCloudsFn = rainControls.setStormClouds ?? null;
  }

  setStorm(duration: number): Promise<void> {
    return new Promise((resolve) => {
      this.map.setFog(FOG_STORM as any);
      this.startRainFn?.();
      this.setStormCloudsFn?.(true);
      setTimeout(resolve, duration);
    });
  }

  setClear(duration: number): Promise<void> {
    return new Promise((resolve) => {
      this.map.setFog(FOG_DEFAULT as any);
      this.stopRainFn?.();
      this.setStormCloudsFn?.(false);
      setTimeout(resolve, duration);
    });
  }

  reset(): void {
    this.map.setFog(FOG_DEFAULT as any);
    this.stopRainFn?.();
    this.setStormCloudsFn?.(false);
  }

  dispose(): void {
    this.reset();
  }
}
